import axios from 'axios';

const state = {
    profile: {
        user: {}
    },
}

const getters = {
    getProfile: state => state.profile,
    getName: state => state.profile.user.name,
    getOrg: state => state.profile.org
}

const actions = {
    async editProfile({ commit }, user) {
        const response = await axios.put('/api/profile', user)
        commit('setUser', response.data)
    },
    async changePassword({ commit }, password) {
        const response = await axios.put('/api/profile/password', password, {
            headers: {
                'Content-Type': 'text/plain',
            }
        })
        const profile = response.data
        commit('setPasswordData', profile)
    }
}

const mutations = {
    setProfile: (state, profile) => (state.profile = profile),
    setUser: (state, user) => (state.profile.user = user),
    setPasswordData: (state, profile) => {
        state.profile.lastPwChange = profile.lastPwChange
        state.profile.daysSinceLastPwChange = profile.daysSinceLastPwChange
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}